export enum JobQualificationsChangeTypeEnum {
    Added,
    Removed,
    Changed,
    Unchanged
}
